// extracted by mini-css-extract-plugin
export default {"section":"SectionCardsGrid__section--lc-nLh4S","component":"SectionCardsGrid__component--lc-_Nls_","item":"SectionCardsGrid__item--lc-uXd_0"};